import { Row, Col } from "antd";
import Container from "../../common/Container";
import { useLanguage } from "../../contexts/LanguageContext";
import { Image } from "../../common/Image";
import {
  FooterSection,
  Extra,
  LogoContainer,
  Para,
  Large,
  Chat,
  FooterContainer,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
} from "./styles";

import * as Si from "react-icons/si";
import { Mail } from "lucide-react";

const SiWhatsapp = Si.SiWhatsapp as unknown as React.FC<{ size?: number }>;
const SiLinkedin = Si.SiLinkedin as unknown as React.FC<{ size?: number }>;
const SiInstagram = Si.SiInstagram as unknown as React.FC<{ size?: number }>;

interface SocialLinkProps {
  href: string;
  children: React.ReactNode;
}

const Footer = () => {
  const { t, setLanguage } = useLanguage();

  const handleChange = (language: 'pt-BR' | 'en' | 'es') => {
    setLanguage(language);
  };

  const SocialLink = ({ href, children }: SocialLinkProps) => (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        color: "inherit",
        padding: "0.25rem",
      }}
    >
      {children}
    </a>
  );

  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={12}>
              <Language>{t.common.contact}</Language>
              <Large to="/">{t.footer.tellUsEverything}</Large>
              <Para>{t.footer.doYouHaveQuestion}</Para>
              <a href="mailto:contato@vizagetec.com">
                <Chat>{t.common.letsChat}</Chat>
              </a>
            </Col>

            <Col lg={8} md={8} sm={12} xs={12}>
              <Language>{t.common.address}</Language>
              <Para>Avenida Professor Moraes Rego, 1235</Para>
              <Para>Cidade Universitária, Recife-PE</Para>
              <Para>50670-901</Para>
            </Col>

            <Col lg={6} md={6} sm={12} xs={12}>
              <Label htmlFor="select-lang">{t.common.language}</Label>
              <LanguageSwitchContainer>
                <LanguageSwitch onClick={() => handleChange("pt-BR")}>PT</LanguageSwitch>
                <LanguageSwitch onClick={() => handleChange("en")}>EN</LanguageSwitch>
                <LanguageSwitch onClick={() => handleChange("es")}>ES</LanguageSwitch>
              </LanguageSwitchContainer>
            </Col>
          </Row>
        </Container>
      </FooterSection>

      <Extra>
        <Container border={true}>
          <Row justify="space-between" align="middle" style={{ paddingTop: "3rem" }}>
            <LogoContainer to="/" aria-label="homepage">
              <Image src="svg/logo_vizageb.png" height="50px" />
            </LogoContainer>

            <FooterContainer>
              {/* WhatsApp */}
              <SocialLink href="https://wa.me/5581998953665">
                <SiWhatsapp size={28} />
              </SocialLink>

              {/* Email */}
              <SocialLink href="mailto:contato@vizagetec.com">
                <Mail size={28} />
              </SocialLink>

              {/* LinkedIn */}
              <SocialLink href="https://www.linkedin.com/company/vizagetec">
                <SiLinkedin size={28} />
              </SocialLink>

              {/* Instagram */}
              <SocialLink href="https://www.instagram.com/vizagetec">
                <SiInstagram size={28} />
              </SocialLink>
            </FooterContainer>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default Footer;
